<!-- AddNewLinkSidebar.vue -->
<template>
  <div>
    <b-modal
      id="help-modal"
      :visible="isHelpModalActive"
      size="xl"
      :title="popupTitle"
      shadow
      backdrop
      no-header
      right
      @hidden="resetForm"
      @change="(val) => $emit('update:is-help-modal-active', val)"
    >
      <template #default="{ hide }">
        <validation-observer ref="refFormObserver" v-slot="{ handleSubmit }">

        <b-form
        @submit.prevent="handleSubmit(onSubmit)"
        @reset.prevent="resetForm"
        id="linkForm"
        >
            <b-form-group
                label="Kategori"
                label-for="help-category"
                class="mb-2"
            >
                <v-select
                id="help-category"
                v-model="helpData.category_id"
                :options="categoryOptions"
                :clearable="false"
                />
            </b-form-group>
            <b-form-group
                label="Başlık"
                label-for="title"
            >
                <b-form-input
                    id="title"
                    v-model="helpData.title"
                    trim
                />
            </b-form-group>

            <b-form-group
                label="İçerik"
                label-for="content"
                class="mb-2"
            >
                <quill-editor
                id="content"
                v-model="helpData.content"
                :options="snowOption"
                style="height: 500px"
                />
            </b-form-group>

        </b-form>
        </validation-observer>
      </template>
      <template #modal-footer="{ hide }">
        <div class="d-flex mt-2 justify-content-between col-12">
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="outline-secondary"
            @click="hide"
            :disabled="addLoading"
          >
            Vazgeç
          </b-button>
          <div class="d-flex">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              type="submit"
              :disabled="addLoading"
              class="ml-2"
              @click="$refs.refFormObserver.validate().then(success => { if (success) { onSubmit(); } })"
            >
              <b-spinner small v-if="addLoading" class="mr-1"/>
              {{ addLoading ? 'İşlem Yapılıyor...' : (editingHelp ? 'Güncelle' : 'Ekle') }}
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
    BModal,
    BButton,
    BForm,
    BInputGroup,
    BFormInput,
    BFormGroup,
    BFormInvalidFeedback,
    BSpinner,   
} from 'bootstrap-vue'

import formValidation from '@core/comp-functions/forms/form-validation'

const {
  refFormObserver,
  resetForm,
} = formValidation()
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive';
import { quillEditor } from 'vue-quill-editor'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default {
    components: {
        BModal,
        BButton,
        BForm,
        BInputGroup,
        BFormInput,
        BFormGroup,
        BFormInvalidFeedback,
        BSpinner,  
        vSelect,
        quillEditor,
        ValidationProvider,
        ValidationObserver
    },
    directives: {
        Ripple,
    },
    props: {
        isHelpModalActive: {
            type: Boolean,
            default: false,
        },
        categoryOptions: {
            type: Array,
            default: () => [],
        },
        editingHelp: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            addLoading: false,
            snowOption: {
                theme: 'snow',
            },
            emptyData: {
                title: '',
                category_id : {},
                content: '',
            },
            helpData : this.emptyData
        }
    },
    
    computed: {
        popupTitle() {
            return this.editingHelp ? 'Yardım Düzenle' : 'Yeni Yardım Ekle';
        },
    },
    methods: {
        resetForm() {
            this.addLoading = false;
            this.helpData = this.emptyData;
        },
        onSubmit() {
            this.addLoading = true;
            const url = this.editingHelp ? `/manage/help/${this.helpData.id}` : '/manage/help';
            const method = this.editingHelp ? 'put' : 'post';
           
            const postData = {
                ...this.helpData,
                category_id: this.helpData.category_id.value, // Kategori ID'sini value olarak gönder
                content: this.helpData.content,
            }
            this.$http[method](url, postData)
                .then((response) => {
                    if(response.data.success) {
                        this.$toast({               
                            component: ToastificationContent,
                            props: {
                                title: this.editingHelp ? 'Yardım Güncellendi' : 'Yardım Eklendi',
                                icon: 'CheckIcon',
                                variant: 'success',
                                text: response.data.message
                            },
                        });
                        this.$emit('update:is-help-modal-active', false);
                        this.$emit('link-updated', response.data);
                    }else{
                        this.$toast(response.data.message)   
                        this.$emit('update:is-help-modal-active', false);
                    }     
                    this.resetForm();  
                    
                })
                .catch((error) => {
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Hata',
                            icon: 'AlertTriangleIcon',
                            variant: 'danger',
                            text: `Yardım ${this.editingHelp ? 'güncellenirken' : 'eklenirken'} hata oluştu: ${error.message}`,
                        },
                    });
                    setTimeout(() => {
                        this.addLoading = false;
                    }, 500);
                })
                .finally(() => {
                    setTimeout(() => {
                        this.addLoading = false;
                    }, 500);
                });             
        }
    },
    created () {
        console.log(this.emptyData);
    },
    watch: {
        categoryOptions: {
            immediate: true,
            handler(newVal) {
                this.emptyData.category_id = newVal[0]; // İlk kategori seçilsin
            }
        },
        isHelpModalActive: {
            immediate: true,
                handler(newVal) {
                if (newVal) {
                    if(this.editingHelp){
                        this.helpData = { ...this.editingHelp,
                            category_id:{
                                value: this.editingHelp.category_id,
                                label: this.editingHelp.category_title
                            }
                        };
                    }else {
                        this.helpData = { ...this.emptyData };
                    }
                   
                } else {
                    this.helpData = this.emptyData;
                }
            }
        }
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/quill.scss';
</style>